@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')"
		header="{{ title }}"
		[(visible)]="display"
		[responsive]="true"
		showEffect="fade"
		[modal]="true"
		appendTo="body"
	>
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<div class="ui-grid-row">
				<div class="ui-grid-col-12">
					<p-messages [(value)]="messages"></p-messages>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.name' | translate }}
					</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="name"
						class="form-control custom-input"
						[(ngModel)]="entity.name"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-6">
					<label for="direction" class="form-label custom-label fw-bold small mb-2 me-2" i18n
						>{{ 'tableManagement.sinister.workshop.direction' | translate }}
					</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="direction"
						class="form-control custom-input"
						[(ngModel)]="entity.direction"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="phoneNumber" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.workshop.phoneNumber' | translate }}
					</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="phoneNumber"
						class="form-control custom-input"
						[(ngModel)]="entity.phoneNumber"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-6">
					<label for="population" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.workshop.population' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="population"
						class="form-control custom-input"
						[(ngModel)]="entity.population"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="province" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.workshop.province' | translate }}
					</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="province"
						class="form-control custom-input"
						[(ngModel)]="entity.province"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-6">
					<label for="cp" class="form-label custom-label fw-bold small mb-2 me-2" i18n>{{
						'tableManagement.sinister.workshop.cp' | translate
					}}</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="cp"
						class="form-control custom-input"
						[(ngModel)]="entity.cp"
						[disabled]="!formManipulation"
					/>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<label for="contactPerson" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'tableManagement.sinister.workshop.contactPerson' | translate }}
					</label>
					<div class="p-0"></div>
					<input
						type="text"
						id="contactPerson"
						class="form-control custom-input"
						[(ngModel)]="entity.contactPerson"
						[disabled]="!formManipulation"
					/>
				</div>
				<div class="col-sm-6"></div>
			</div>
			<!-- ACTIVE -->
			@if (!isNew) {
				<div class="row mt-3">
					<div class="col-12">
						<label for="cardType-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'general.active' | translate }}
						</label>
						<input
							class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
							type="checkbox"
							[(ngModel)]="active"
							[disabled]="true"
						/>
					</div>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" [disabled]="!formManipulation" i18n>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" [disabled]="!formManipulation" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
				<div class="p-2 bd-highlight">
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="changeStatus(active)" [disabled]="!disableGranted" i18n>
								{{ 'general.changeStatus' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
